import { render, staticRenderFns } from "./KnTableStudent.vue?vue&type=template&id=ac25c61c&scoped=true"
import script from "../KnTableStudent/KnTableStudent.js?vue&type=script&lang=js&external"
export * from "../KnTableStudent/KnTableStudent.js?vue&type=script&lang=js&external"
import style0 from "./KnTableStudent.vue?vue&type=style&index=0&id=ac25c61c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac25c61c",
  null
  
)

export default component.exports